import type { JobCreateRequest, JobUpdateRequest } from '../model/job';
import type { AxiosRequestConfig } from 'axios';
import { monitoringInstance } from '@/shared/api/api-instances/monitoring/api-instance';
import type { Job } from '../model/job';
import { Page, PaginationParams } from '@/shared/api/pagination';
import { ImportEntities } from '@/shared/api/import-contracts';

const baseURL = '/api/monitoring/v4/';
const defaultOptions = { baseURL };
export class JobsAPI {
  static getJobs(params: PaginationParams, options?: AxiosRequestConfig) {
    return monitoringInstance.get<Page<Job>>('/jobs', {
      ...defaultOptions,
      ...options,
      params: params,
    });
  }

  // static getConfigJobs(options?: AxiosRequestConfig) {
  //   return monitoringInstance.get<Job[]>('/prometheus/config/jobs', options);
  // }
  static getJobByName(name: string, options?: AxiosRequestConfig) {
    return monitoringInstance.get<Job>(`/job/${name}`, {
      ...defaultOptions,
      ...options,
    });
  }

  static createJob(
    payload: JobCreateRequest,
    options: AxiosRequestConfig = {},
  ) {
    return monitoringInstance.post<Job>(`/job`, payload, {
      ...defaultOptions,
      ...options,
    });
  }

  static updateJob(
    id: string,
    payload: JobUpdateRequest,
    force: boolean = false,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.put<Job>(`/job/${id}`, payload, {
      ...defaultOptions,
      ...options,
      params: {
        force,
      },
    });
  }

  static deleteJob(
    name: string,
    force: boolean = false,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.delete(`/job/${name}`, {
      ...defaultOptions,
      ...options,
      params: {
        force,
      },
    });
  }

  // static exportJobs(job_names: string[], options?: AxiosRequestConfig) {
  //   return monitoringInstance.get<{
  //     jobs: Job[];
  //   }>('/prometheus/job/export/json', {
  //     ...options,
  //     params: { job_names },

  //     paramsSerializer: () => {
  //       const searchParams = new URLSearchParams();
  //       job_names.forEach((name) => searchParams.append('job_names', name));
  //       return searchParams.toString();
  //     },
  //   });
  // }

  static exportJobs(job_names: string[], options?: AxiosRequestConfig) {
    return monitoringInstance.get('/job/export/json', {
      ...defaultOptions,
      ...options,
      params: { job_names },

      paramsSerializer: () => {
        const searchParams = new URLSearchParams();
        job_names.forEach((name) => searchParams.append('job_names', name));
        return searchParams.toString();
      },
    });
  }

  static analyzeJobsEntities(json: string, options?: AxiosRequestConfig) {
    return monitoringInstance.post('/import/job/analyze', json, {
      ...defaultOptions,
      ...options,
    });
  }

  static executeJobsEntities(
    data: ImportEntities,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.post('/import/job/execute', data, {
      ...defaultOptions,
      ...options,
    });
  }

  static validateImport(json: string, options?: AxiosRequestConfig) {
    return monitoringInstance.post('/import/job/analyze', json, {
      ...defaultOptions,
      ...options,
    });
  }
}